import React, { Fragment } from "react";

import { arrayOf, object } from "prop-types";

import moment from "moment";
import { Link } from "react-router-dom";
import history from "../../history";

import * as style from "./styles.module.scss";

import { getStatusName, checkIfHidden } from "../../helpers/timesheets";
import LabeledValue from "../LabeledValue";
import OverflowedText from "../../common/OverflowedText";
import LoadingSpinner from "../../icons/LoadingSpinner";

const rowActions = (ts, statusName) => {
  if (ts.isUpdating) {
    return <LoadingSpinner />;
  }
  return (
    <Fragment>
      <Link to={`/profile/edit/Timesheets/${ts.timesheetRef}`}>
        <button
          className={`btn btn-primary btn-block ${style.timesheet__status_button}`}
        >
          {statusName === "rejected" && "Update"}
          {(statusName === "incomplete" || statusName === "new") && "Complete"}
          {(statusName === "pending" || statusName === "approved") &&
            "View"}{" "}
          <span className="d-inline-block">timesheet</span>
        </button>
      </Link>
    </Fragment>
  );
};

const TimesheetsTable = ({ timesheets }) => (
  <div>
    <table className={`${style.table} d-none d-lg-table`}>
      <thead>
        <tr>
          <th></th>
          <th></th>
          <th>Week Ending:</th>
          <th>Job Title:</th>
          <th>Company:</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {timesheets.map((ts) => {
          const {
            jobTitle,
            timesheetRef,
            organisationTitle,
            endDate,
            calculatedStatusCode,
            rejected,
            submitted = false,
          } = ts;
          const isHidden = checkIfHidden(calculatedStatusCode);
          const statusName = getStatusName(
            calculatedStatusCode,
            rejected,
            submitted
          );
          const statusClassName = style[`timesheet__status__${statusName}`];

          return (
            !isHidden && (
              <tr key={timesheetRef}>
                <td>
                  <div
                    className={`${style.timesheet__status} ${statusClassName}`}
                  >
                    {statusName}
                  </div>
                </td>
                <td></td>
                <td>{moment(endDate).format("DD/MM/YY")}</td>
                <td>
                  <OverflowedText overflowedText={jobTitle}>
                    {jobTitle}
                  </OverflowedText>
                </td>
                <td>
                  <OverflowedText overflowedText={organisationTitle}>
                    {organisationTitle}
                  </OverflowedText>
                </td>
                <td>{rowActions(ts, statusName)}</td>
              </tr>
            )
          );
        })}
      </tbody>
    </table>

    <div className="d-lg-none">
      {timesheets.map((ts) => {
        const {
          jobTitle,
          timesheetRef,
          organisationTitle,
          endDate,
          calculatedStatusCode,
          rejected,
          submitted = false,
        } = ts;
        const isHidden = checkIfHidden(calculatedStatusCode);
        const statusName = getStatusName(
          calculatedStatusCode,
          rejected,
          submitted
        );
        const statusClassName = style[`timesheet__status__${statusName}`];

        return (
          !isHidden && (
            <article className={style.timesheetMobile} key={timesheetRef}>
              <div className="d-flex justify-content-between">
                <LabeledValue header="week ending" className="d-block mb-1">
                  {moment(endDate).format("DD/MM/YY")}
                </LabeledValue>
                <div
                  className={`${style.timesheet__status} ${statusClassName}`}
                >
                  {statusName.toUpperCase()}
                </div>
              </div>
              <div className="w-100">
                <LabeledValue
                  header="job title"
                  className={`d-block mb-1 ${style.timesheetMobile__item}`}
                >
                  <OverflowedText overflowedText={jobTitle}>
                    {jobTitle}
                  </OverflowedText>
                </LabeledValue>
                <LabeledValue
                  header="company"
                  className={`d-block mb-1 ${style.timesheetMobile__item}`}
                >
                  <OverflowedText overflowedText={organisationTitle}>
                    {organisationTitle}
                  </OverflowedText>
                </LabeledValue>
              </div>
              <div className="w-100 d-flex flex-row-reverse">
                <span>{rowActions(ts, statusName)}</span>
              </div>
            </article>
          )
        );
      })}
    </div>
  </div>
);

TimesheetsTable.propTypes = {
  timesheets: arrayOf(object),
};

export default TimesheetsTable;
